import { Component, Input, OnInit, inject } from '@angular/core';
import { IJobOffer } from '../../../../../../assets/types/dtoTypes';
import { ImageService } from '../../../../../shared/services/image.service';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-job-offer-card',
  templateUrl: './job-offer-card.component.html',
  styleUrls: ['./job-offer-card.component.scss'],
  imports: [
    TranslateModule,
    NgForOf,
    NgIf,
  ],
  standalone: true
})
export class JobOfferCardComponent implements OnInit {
  private imageService = inject(ImageService);
  private translate = inject(TranslateService);

  @Input() offer!: IJobOffer;
  companyLogoSrc = '';

  isLoading = true;

  constructor() {
  }

  ngOnInit() {
    if (!this.offer) {
      this.isLoading = false;
      return;
    }

    this.imageService.appendSasTokenToCompanyImage( this.offer.companyLogoUrl, this.offer.companyId, true ).subscribe( ( url ) => {
      this.offer.companyLogoUrl = url;
      this.companyLogoSrc = url;
      this.isLoading = false;
    } );
  }

  getTimeAgo(dateString: string): string {
    const now = new Date();
    const createdDate = new Date(dateString);
    createdDate.setHours(createdDate.getHours() + 2); // timezone adjustment if needed

    const diffInSeconds = Math.floor((now.getTime() - createdDate.getTime()) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInSeconds < 60) {
      return this.translate.instant('timeAgo.justNow');
    } else if (diffInMinutes < 60) {
      const key = diffInMinutes === 1 ? 'timeAgo.minutesAgo' : 'timeAgo.minutesAgo_plural';
      return this.translate.instant(key, { count: diffInMinutes });
    } else if (diffInHours < 24) {
      const key = diffInHours === 1 ? 'timeAgo.hoursAgo' : 'timeAgo.hoursAgo_plural';
      return this.translate.instant(key, { count: diffInHours });
    } else if (diffInDays < 7) {
      const key = diffInDays === 1 ? 'timeAgo.daysAgo' : 'timeAgo.daysAgo_plural';
      return this.translate.instant(key, { count: diffInDays });
    } else if (diffInDays < 30) {
      const diffInWeeks = Math.floor(diffInDays / 7);
      const key = diffInWeeks === 1 ? 'timeAgo.weeksAgo' : 'timeAgo.weeksAgo_plural';
      return this.translate.instant(key, { count: diffInWeeks });
    } else {
      const nowMonth = now.getMonth();
      const nowYear = now.getFullYear();
      const createdMonth = createdDate.getMonth();
      const createdYear = createdDate.getFullYear();

      const totalMonthsNow = nowYear * 12 + nowMonth;
      const totalMonthsCreated = createdYear * 12 + createdMonth;
      const diffInMonths = totalMonthsNow - totalMonthsCreated;

      if (diffInMonths < 12) {
        const key = diffInMonths === 1 ? 'timeAgo.monthsAgo' : 'timeAgo.monthsAgo_plural';
        return this.translate.instant(key, { count: diffInMonths });
      } else {
        const diffInYears = Math.floor(diffInMonths / 12);
        const key = diffInYears === 1 ? 'timeAgo.yearsAgo' : 'timeAgo.yearsAgo_plural';
        return this.translate.instant(key, { count: diffInYears });
      }
    }
  }

}
